import * as commonUtils from '@dbp-toolkit/common/utils';
import {TooltipElement} from './tooltip';

commonUtils.defineCustomElement('dbp-tooltip', TooltipElement);
